import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "tw-flex tw-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "tw-ml-1 tw-text-[#F7553C]"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-flex tw-gap-2 tw-items-center tw-w-full tw-relative"
}
const _hoisted_5 = {
  key: 0,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-absolute tw-right-[10px]"
}
const _hoisted_6 = { key: 0 }

import { any } from "joi";
import _ from "underscore";
import { ref, watch } from "vue";
import VRuntimeTemplate from "vue3-runtime-template";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'baseInput',
  props: {
  /** The model and value of the input */
  modelValue: { type: null, required: true },
  /** Vue Validation object */
  validation: { type: Object, default: () => ({}) },
  /** Flag to indicate if validation should occur on blur */
  validateOnBlur: { type: Boolean, default: false },
  /** CSS class name */
  className: { type: String, default: "" },
  dataCyId: { type: String, default: "" },
  /** CSS label class name */
  idFocus: { type: String, default: "" },
  /** CSS label class name */
  labelClass: { type: String, default: "" },
  /** CSS label class name */
  inputClass: { type: String, default: "" },
  /** Placeholder text for the input */
  placeholder: { type: String, default: "" },
  /** Label for the input */
  label: { type: String, default: "" },
  /** Tooltip text for the label */
  labelTooltip: { type: String, default: "" },
  labelTooltipClass: { type: String, default: "" },
  /** Flag to indicate if the component should be refreshed */
  isRefresh: { type: Boolean, default: false },
  /** Type of the input (e.g., 'text', 'password', etc.) */
  type: { type: String, default: "text" },
  isSkeleton: { type: Boolean, requied: false, default: false },
  colTitle: { type: Number, required: false, default: 5 },
  colInput: { type: Number, required: false, default: 7 },
  disabled: { type: Boolean, required: false, default: false },
  validClass: { type: String, required: false, default: "" },
  container: { type: String, required: false, default: "" },
  colInputClass: { type: String, required: false, default: "" },
  readOnly: { type: Boolean, required: false, default: false },
  classNameLabel: { type: String, required: false, default: "" },
  isRequired: { type: Boolean, required: false, default: false },
  isLoadingAnimation: { type: Boolean, required: false, default: false },
  isFocusSlot: { type: Boolean, required: false, default: false },
},
  emits: [
  /** Event on value update */
  "update:modelValue",
  "blur",
  "focus",
  "keydown",
  "change",
],
  setup(__props, { emit }) {

const props = __props;



const isFocus = ref(false);


const currentValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    props.isRefresh && (currentValue.value = props.modelValue);
    currentValue.value = props.modelValue;
  },
);

watch(
  () => props.isFocusSlot,
  () => {
    isFocus.value = props.isFocusSlot;
  },
);

const handleInput = (val: string) => {
  if (_.isEmpty(props.validation) === false) {
    if (val.trim() === "") props.validation?.$reset?.();
    else props.validation?.$touch?.();
  }
  currentValue.value = val;
  emit("update:modelValue", currentValue.value);
  emit("change", currentValue.value);
};

const onBlur = () => {
  props.validateOnBlur && props.validation?.$touch && props.validation.$touch();
  isFocus.value = false;
  emit("blur");
};

const onFocus = () => {
  isFocus.value = true;
  emit("focus");
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${__props.container}`)
  }, [
    _createVNode(_component_b_row, {
      class: _normalizeClass(`tw-mt-[20px] align-items-start ${
        __props.disabled ? 'tw-pointer-events-none' : ''
      } ${__props.className}`)
    }, {
      default: _withCtx(() => [
        (__props.label)
          ? (_openBlock(), _createBlock(_component_b_col, {
              key: 0,
              sm: __props.colTitle,
              class: _normalizeClass(__props.labelClass)
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _renderSlot(_ctx.$slots, "icon")
                ]),
                _createElementVNode("label", {
                  class: _normalizeClass(`label-form tw-text-[14px] tw-font-[500] tw-leading-[100%] tw-mb-0 ${__props.classNameLabel}`),
                  for: `inputItem.valueField`
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(__props.label) + " ", 1),
                    (__props.validation.required || __props.isRequired)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "rightTitle")
                  ]),
                  (__props.labelTooltip)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(`tw-block tw-font-[400] tw-text-[13px] tw-text-[#878787] tw-leading-normal tw-mt-[4px] label-tooltip tw-w-[70%] ${__props.labelTooltipClass}`)
                      }, _toDisplayString(__props.labelTooltip), 3))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_1)
              ]),
              _: 3
            }, 8, ["sm", "class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_b_col, {
          sm: __props.colInput,
          class: _normalizeClass(`${__props.colInputClass} lg:tw-px-[13.79px]`)
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              (!__props.isSkeleton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_BFormInput, {
                      id: __props.idFocus,
                      modelValue: currentValue.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
                      "data-cy": __props.dataCyId,
                      readonly: __props.readOnly,
                      autocomplete: "new-password",
                      type: __props.type,
                      placeholder: __props.placeholder,
                      class: _normalizeClass([
                'input-base-form-input autoFocus tw-relative',
                __props.validation.$error &&
                (!isFocus.value ||
                  (isFocus.value &&
                    ((__props.validation?.$errors?.[0]?.$validator !== 'email' &&
                      __props.validation?.$errors?.[0]?.$validator !== 'domain' &&
                      __props.validation?.$errors?.[0]?.$validator !== 'phoneNumber' &&
                      __props.validation?.$errors?.[0]?.$validator !== 'url') ||
                      __props.validation?.isValidCharacter?.$invalid)))
                  ? 'is-invalid'
                  : '',
                __props.disabled ? '!tw-text-[#B7B7B7]' : '',
                'no-spinner',
                __props.inputClass,
                __props.isLoadingAnimation ? '!tw-pr-[50px]' : '',
              ]),
                      state: __props.validation.dirty ? __props.validation.$error : null,
                      onKeydown: _cache[1] || (_cache[1] = (evt) => emit('keydown', evt)),
                      onBlur: onBlur,
                      onFocus: onFocus,
                      onInput: handleInput
                    }, null, 8, ["id", "modelValue", "data-cy", "readonly", "type", "placeholder", "class", "state"]),
                    (__props.isLoadingAnimation)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_unref(LottieAnimation), {
                            ref: "anim",
                            "animation-data": _unref(ProgressAnimation),
                            "auto-play": true,
                            loop: true
                          }, null, 8, ["animation-data"])
                        ]))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "rightInput")
                  ]))
                : (_openBlock(), _createBlock(_component_BFormInput, {
                    key: 1,
                    class: "input-base-form-skeleton"
                  }))
            ]),
            (__props.validation?.$errors?.[0]?.$message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "feedback", {}, () => [
                    _createElementVNode("div", {
                      class: _normalizeClass(`${__props.validClass}`)
                    }, [
                      (
                  !isFocus.value ||
                  (isFocus.value &&
                    ((__props.validation?.$errors?.[0]?.$validator !== 'email' &&
                      __props.validation?.$errors?.[0]?.$validator !== 'domain' &&
                      __props.validation?.$errors?.[0]?.$validator !== 'phoneNumber' &&
                      __props.validation?.$errors?.[0]?.$validator !== 'url') ||
                      __props.validation?.isValidCharacter?.$invalid))
                )
                        ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                            key: 0,
                            class: _normalizeClass({ 'is-invalid': __props.validation.$error })
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(VRuntimeTemplate), {
                                template: __props.validation?.$errors?.[0]?.$message
                              }, null, 8, ["template"])
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["sm", "class"])
      ]),
      _: 3
    }, 8, ["class"])
  ], 2))
}
}

})